// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.escher-container .search-container {
  display: flex;
  flex-direction: row;
  background-color: rgba(255, 255, 255, 0.95);
  padding: 3px;
  border: 1px solid #DDD;
}

.escher-container .search-container .search-field {
  flex: 0 0 auto;
  color: #777;
  border: 1px solid #DDD;
  width: 114px;
  height: 29px;
  border-radius: 3px;
  font-size: 13px;
}

.escher-container .search-container .search-counter {
  flex: 1;
  color: #777;
  font-size: 13px;
  padding: 9px 0 0 6px;
}

.escher-container .search-container .search-bar-button {
  flex: 0 0 auto;
  border-radius: 4px;
  text-align: center;
  vertical-align: middle;
  font-size: 14px;
  font-weight: 400;
  height: 29px;
  width: 34px;
  margin: 3px;
}

.escher-container .search-container .search-bar-button.left {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  margin-right: 0;
}

.escher-container .search-container .search-bar-button.right {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  margin-left: 0;
}

.escher-container .search-container .search-bar-button:active {
  background-image: linear-gradient(#3F4141, #474949 6%, #4F5151);
}
`, "",{"version":3,"sources":["webpack://./src/SearchBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,+DAA+D;AACjE","sourcesContent":[".escher-container .search-container {\n  display: flex;\n  flex-direction: row;\n  background-color: rgba(255, 255, 255, 0.95);\n  padding: 3px;\n  border: 1px solid #DDD;\n}\n\n.escher-container .search-container .search-field {\n  flex: 0 0 auto;\n  color: #777;\n  border: 1px solid #DDD;\n  width: 114px;\n  height: 29px;\n  border-radius: 3px;\n  font-size: 13px;\n}\n\n.escher-container .search-container .search-counter {\n  flex: 1;\n  color: #777;\n  font-size: 13px;\n  padding: 9px 0 0 6px;\n}\n\n.escher-container .search-container .search-bar-button {\n  flex: 0 0 auto;\n  border-radius: 4px;\n  text-align: center;\n  vertical-align: middle;\n  font-size: 14px;\n  font-weight: 400;\n  height: 29px;\n  width: 34px;\n  margin: 3px;\n}\n\n.escher-container .search-container .search-bar-button.left {\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n  margin-right: 0;\n}\n\n.escher-container .search-container .search-bar-button.right {\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  margin-left: 0;\n}\n\n.escher-container .search-container .search-bar-button:active {\n  background-image: linear-gradient(#3F4141, #474949 6%, #4F5151);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
